// eslint-disable-next-line import/no-anonymous-default-export
export default {
  serverName: process.env.REACT_APP_SERVERNAME,
  mainDir: process.env.REACT_APP_MAINDIR,
  clientId: process.env.REACT_APP_CLIENTID,
  googleAuthUrl: process.env.REACT_APP_GOOGLE_AUTH_URL,
  apiUrl: process.env.REACT_APP_APIURL,
  baseUrl: process.env.REACT_APP_BASEURL,
  site: {},
};
